export default class WifiConfigurationService {
  constructor($q, BoxCaster, $timeout) {
    'ngInject';

    this.$q = $q;
    this.BoxCaster = BoxCaster;
    this.$timeout = $timeout;
  }

  getConfig(boxcasterId) {
    // Returns a promise that is fullfilled when the result of the
    // `get_wifi_config` RPC completes.
    let { BoxCaster, $timeout, $q } = this;

    let deferred = $q.defer();
    let startTime = new Date().getTime();
    let pollingId = null;
    let wifiConfig = null;

    let handleResult = () => {
      if (wifiConfig.response && !wifiConfig.error) {
        deferred.resolve(this.mungeApiResponse(wifiConfig.response));
      } else if (wifiConfig.error) {
        deferred.reject(wifiConfig.response);
      } else if (new Date().getTime() - startTime > WIFI_POLL_TIMEOUT_MS) {
        deferred.reject('timeout');
        this.destroy();
      } else {
        this.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
      }
    };

    let poll = function () {
      if (!pollingId) {
        // Start the RPC
        wifiConfig = BoxCaster.postRPC(
          { id: boxcasterId },
          { request: 'get_wifi_config' },
          () => {
            pollingId = wifiConfig.id;
            handleResult();
          },
          () => deferred.reject('Unable to get Wi-Fi config')
        );
      } else {
        // Check status of existing RPC call to get wireless networks
        wifiConfig = BoxCaster.getRPC(
          { id: boxcasterId, rpcId: pollingId },
          () => handleResult(),
          () => deferred.reject('Unable to get Wi-Fi config')
        );
      }
    };

    this.destroy = () => {
      console.log('Destroying the old RPC call');
      this.$timeout.cancel(this.timeoutHandle);
      BoxCaster.deleteRPC({ id: boxcasterId, rpcId: pollingId });
    };

    poll();

    return deferred.promise;
  }

  setConfig(boxcasterId, config) {
    // Returns a promise that is fullfilled when the result of the
    // `set_wifi_config` RPC completes.
    let { BoxCaster, $timeout, $q } = this;

    let deferred = $q.defer();
    let pollingId = null;
    let wifiConfig = null;

    let handleResult = () => {
      if (wifiConfig.response && !wifiConfig.error) {
        deferred.resolve(wifiConfig.response);
      } else if (wifiConfig.error) {
        deferred.reject(wifiConfig.response);
      } else {
        this.timeoutHandle = $timeout(poll, WIFI_POLL_INTERVAL_MS);
      }
    };

    let poll = function () {
      if (!pollingId) {
        // Start the RPC
        wifiConfig = BoxCaster.postRPC(
          { id: boxcasterId },
          { request: { message: 'set_wifi_config', config: config } },
          () => {
            pollingId = wifiConfig.id;
            handleResult();
          },
          () => deferred.reject('Unable to set Wi-Fi config')
        );
      } else {
        // Check status of existing RPC call to get wireless networks
        wifiConfig = BoxCaster.getRPC(
          { id: boxcasterId, rpcId: pollingId },
          () => handleResult(),
          () => deferred.reject('Unable to set Wi-Fi config')
        );
      }
    };

    poll();

    return deferred.promise;
  }

  mungeApiResponse(response) {
    // XXX: looks like Ruby is doing some weird stuff to the RPC result (turning
    // empty arrays to nulls). We'll work around it here to avoid hacking away
    // at the ruby code.
    if (response.current && !response.current.networks) {
      response.current.networks = [];
    }
    if (!response.scan_results) {
      response.scan_results = [];
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./app/pages/settings/wifi-configuration-service.js